import React from 'react'
import { Skeleton, Box } from '@mui/material'
import { ButtonIconSeeker } from '@ui-seeker/core'

import { useToast } from '@hooks'
import { BACKEND_APIS } from '@constants'
import { TitleWithPopover, AppTableSeeker } from "@components";
import { numColumn, retailerColumn } from './columns'
import { useCustomersSiteTableFilters} from "./@hooks";
import { customerDetailsFilters } from "../@signals";


export default function CustomersSiteTable() {

    const { data, isLoading } = useCustomersSiteTableFilters()
    const { showToast } = useToast()

    if (isLoading) return <Skeleton variant="rectangular" height={500} />
    if (!data.length) return <></>

    const columns = [
        numColumn('siteID', 'Site ID'),
        ...retailerColumn(),
    ]

    return <Box id="customer-sites-info">
        <AppTableSeeker
            data={data}
            title={<TitleWithPopover title={"Sites Info for customer " + customerDetailsFilters.value?.name} />}
            columns={columns}
            options={{
                tableBodyHeight: '600',
                onDownload: () => showToast.promiseExcel(`${BACKEND_APIS.MANAGEMENT}/customer/customer-sites-excel`, customerDetailsFilters.value),
                viewColumns: false,
                customToolbar: () => <ButtonIconSeeker
                    icon="circle-xmark"
                    onClick={() => {
                        customerDetailsFilters.value = {}
                    }}
                    tooltip="Close Customer Details"
                />
            }}
        />
    </Box>
}